import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'

const FONT_MONO = "'Roboto Mono', monospace"

type Props = {
  messages: string[]
}

const ExampleMessages = ({ messages }: Props) => {
  const [css] = useStyletron()

  if (messages.length === 0) return null

  return (
    <>
      {messages.map((msg, idx) => (
        <Text.BodyText3
          key={idx}
          color="grey70"
          className={css({
            display: 'block',
            fontFamily: FONT_MONO,
            fontWeight: 400,
            marginBottom: idx < messages.length - 1 ? '0.25rem' : '0',
          })}
        >
          {msg}
        </Text.BodyText3>
      ))}
    </>
  )
}

export default ExampleMessages
